import {useCallback,useEffect,useState} from 'react';
import type {Backend,TicketStatusDefinition} from '../api';
import {defaultTicketStatuses} from '../ticketStatuses';
import {handleSessionError} from '../session';

export function useTicketStatuses(backend:Backend,onUnauthorized:()=>void,enabled=true){
 const [items,setItems]=useState<TicketStatusDefinition[]>(defaultTicketStatuses),[error,setError]=useState(''),[revision,setRevision]=useState(0);
 const reload=useCallback(()=>setRevision(value=>value+1),[]);
 useEffect(()=>{let live=true;setError('');if(!enabled||!backend.ticketStatuses)return;
  backend.ticketStatuses().then(value=>{if(live)setItems(value.items);}).catch(cause=>{if(live&&handleSessionError(cause,onUnauthorized)!=='unauthorized')setError('Не удалось загрузить список статусов. Обновите раздел.');});
  return()=>{live=false;};
 },[backend,onUnauthorized,revision,enabled]);
 return {items,error,reload};
}
